export const SeriesAlertId = 'alert';
export const SeriesStoplightId = 'stoplight';
export const SeriesStoplightRedId = 'stoplight_red_series';
export const SeriesStoplightGreenId = 'stoplight_green_series';
export const SeriesPrimaryId = 'primary';
export const SeriesMeasurementId = 'measurement';
export const SeriesMovingAverageId = 'moving_average';
export const SeriesOverlayId = 'overlay';
export const SeriesOverlayRightAxisId = 'overlay_right_axis';
